// Store logo for headers: always a square tile. Logos arrive in any shape,
// so the fit adapts: tall or square logos fill the square (cropping their
// padding), while wide wordmarks are scaled down to fit whole instead of
// losing their ends. Size the tile's height in CSS.
import { useState } from 'react';
import ImageWithFallback from '@components/base/ImageWithFallback';

export default function BrandLogo({ src, className, radius = '0.5rem' }) {
  const [isWide, setIsWide] = useState(false);

  return (
    <ImageWithFallback
      src={src}
      alt=""
      className={className}
      aspectRatio="1 / 1"
      fit={isWide ? 'contain' : 'cover'}
      radius={radius}
      // A contained wordmark leaves bands above and below; keep the tile solid.
      style={{ background: '#ffffff' }}
      loading="eager"
      onLoad={(event) => {
        const { naturalWidth, naturalHeight } = event.currentTarget;
        if (naturalWidth && naturalHeight) setIsWide(naturalWidth > naturalHeight);
      }}
    />
  );
}
